import { showPromptDialog, showSuccessToast } from '@bpinternal/ui-kit-next'
import { useRenameBot } from './useRenameBot'
import { RenamePrompt } from '~/features/home/components/RenamePrompt'

type UseRenameBotDialogProps = {
  botId: string
  workspaceId: string
  currentBotName: string
}

export const useRenameBotDialog = ({ botId, workspaceId, currentBotName }: UseRenameBotDialogProps) => {
  const { mutate: renameBot } = useRenameBot()

  const openRenameDialog = () => {
    showPromptDialog<string>(
      ({ value, setValue, setValid }) => (
        <RenamePrompt value={value} setValue={setValue} setValid={setValid} currentBotName={currentBotName} />
      ),
      {
        title: 'Rename Bot',
        confirmLabel: 'Rename',
        cancelLabel: 'Cancel',
      }
    )
      .then((newName) => {
        if (newName && newName.trim() !== currentBotName) {
          renameBot({
            botId,
            workspaceId,
            name: newName.trim(),
            onSuccess: () => {
              showSuccessToast(`Bot has been successfully renamed to "${newName.trim()}"`)
            },
          })
        }
      })
      .catch(() => {})
  }

  return {
    openRenameDialog,
  }
}
